export const ELEMENT_WITH_ANSWER_KEY = [
  'text',
  'email',
  'phone',
  'number',
  'date',
  'time',
  'datetimelocal',
  'yesno',
  'yesnona',
  'radiogroup',
  'checkbox',
  'dropdown',
  'multipleselect',
  'files',
  'images',
  'signature',
  'multisignature',
];

export const ELEMENTS_WITH_SELECTED_LINK_LIST_LABEL = [
  'radiogroup',
  'multipleselect',
  'checkbox',
  'dropdown',
];
